import React from 'react';
import BenefitsSection from './common/BenefitsSection';
import ProductCTA from './common/ProductCTA';
import PageSEO from './common/PageSEO';
import ClientLogos from './ClientLogos';
import { useT } from '../i18n';

const T = {
  es: {
    seo: {
      title: "Cadenia Visibility - Trazabilidad y Seguimiento de Envíos en Tiempo Real",
      description: "Centralice datos de todos sus transportistas en una sola plataforma. Seguimiento completo de envíos con trazabilidad, ETAs dinámicos, alertas proactivas y visibilidad unificada 360.",
      keywords: "trazabilidad envíos, seguimiento tiempo real, visibilidad cadena suministro, ETA dinámico, seguimiento GPS transporte, alertas logísticas, gestión envíos",
    },
    benefits: [
      {
        title: "Fuente Única de Verdad",
        description: "Equipos internos, clientes y proveedores consultan la misma información actualizada, mejorando coordinación y confianza."
      },
      {
        title: "Gestión Proactiva",
        description: "Anticipe retrasos y resuelva incidencias con alertas tempranas y ETA dinámico."
      },
      {
        title: "Eficiencia Operativa",
        description: "Herramientas diseñadas para mejorar la eficiencia de su Cadena de Suministro."
      }
    ],
    hero: {
      subtitle: "Centralice datos de todos sus transportistas en una sola plataforma. Seguimiento completo de envíos con trazabilidad y visibilidad en tiempo real, ETAs dinámicos y gestión proactiva de incidencias.",
      cta: "Ver Demo de Visibility",
    },
    mockup: {
      moduleLabel: "Módulo",
      submenu: ['Búsqueda', 'Envíos', 'Rutas', 'Tiempo Real'],
      bottomItems: ['Soporte', 'Mi Perfil'],
      pageTitle: "Todos los Envíos",
      toolbarButtons: ['Filtros', 'Ordenación', 'Excel'],
      refresh: "Actualizar",
      views: [
        { label: 'Todos los Envíos', active: true },
        { label: 'Pendientes de recogida', active: false },
        { label: 'En tránsito', active: false },
        { label: 'Incidencias', active: false },
      ],
      columns: {
        reference: "Referencia",
        route: "Origen → Destino",
        date: "Fecha",
        status: "Estado",
        carrier: "Transportista",
      },
      rows: [
        { ref: '10234801', from: 'Madrid, 28045', to: 'Sevilla, 41012', date: '21/4', status: 'Pendiente', statusStyle: 'bg-slate-50 text-slate-600 border-slate-200', barColor: 'bg-slate-300', barWidth: 'w-1/6', carrier: 'TR. LÓPEZ' },
        { ref: '10234798', from: 'Barcelona, 08019', to: 'Valencia, 46021', date: '21/4', status: 'Pendiente', statusStyle: 'bg-slate-50 text-slate-600 border-slate-200', barColor: 'bg-slate-300', barWidth: 'w-1/6', carrier: 'LOGÍSTICA SUR' },
        { ref: '10234795', from: 'Zaragoza, 50018', to: 'Bilbao, 48013', date: '17/4', status: 'Entregado', statusStyle: 'bg-green-50 text-green-700 border-green-200', barColor: 'bg-green-500', barWidth: 'w-full', carrier: 'NORTE EXPRESS' },
        { ref: '10234790', from: 'Valencia, 46021', to: 'Málaga, 29010', date: '20/4', status: 'En Tránsito', statusStyle: 'bg-slate-50 text-slate-600 border-slate-200', barColor: 'bg-blue-400', barWidth: 'w-3/5', carrier: 'TR. GARCÍA' },
        { ref: '10234787', from: 'Sevilla, 41012', to: 'Barcelona, 08019', date: '17/4', status: 'En Tránsito', statusStyle: 'bg-slate-50 text-slate-600 border-slate-200', barColor: 'bg-blue-400', barWidth: 'w-2/5', carrier: 'IBÉRICA LOG.' },
        { ref: '10234782', from: 'Bilbao, 48013', to: 'Madrid, 28045', date: '20/4', status: 'En Tránsito', statusStyle: 'bg-slate-50 text-slate-600 border-slate-200', barColor: 'bg-blue-400', barWidth: 'w-4/5', carrier: 'LOGÍSTICA SUR' },
      ],
      mobileRows: [
        { ref: '10234801', from: 'Madrid, 28045', to: 'Sevilla, 41012', status: 'Pendiente', statusStyle: 'bg-slate-50 text-slate-600 border-slate-200', barColor: 'bg-slate-300', barWidth: 'w-1/6', carrier: 'TR. LÓPEZ', date: '21/4' },
        { ref: '10234795', from: 'Zaragoza, 50018', to: 'Bilbao, 48013', status: 'Entregado', statusStyle: 'bg-green-50 text-green-700 border-green-200', barColor: 'bg-green-500', barWidth: 'w-full', carrier: 'NORTE EXPRESS', date: '17/4' },
        { ref: '10234790', from: 'Valencia, 46021', to: 'Málaga, 29010', status: 'En Tránsito', statusStyle: 'bg-slate-50 text-slate-600 border-slate-200', barColor: 'bg-blue-400', barWidth: 'w-3/5', carrier: 'TR. GARCÍA', date: '20/4' },
        { ref: '10234787', from: 'Sevilla, 41012', to: 'Barcelona, 08019', status: 'En Tránsito', statusStyle: 'bg-slate-50 text-slate-600 border-slate-200', barColor: 'bg-blue-400', barWidth: 'w-2/5', carrier: 'IBÉRICA LOG.', date: '17/4' },
      ],
      totalShipments: "1.149 envíos",
    },
    connectivity: {
      badge: "CONECTIVIDAD",
      titleStart: "Todos sus transportistas,",
      titleHighlight: "una sola plataforma",
      p1: "Las redes de transporte y distribución reales son complejas: decenas de proveedores con tecnologías, formatos y capacidades muy diferentes. Desde el transportista local de dos camiones hasta el operador logístico global.",
      p2: "Cadenia es especialista en agregar esa heterogeneidad. Conectamos con todos los actores de su cadena de suministro y normalizamos la información en un modelo único, sin importar el origen. Clientes nuestros operan con más de 50 empresas transportistas conectadas simultáneamente en la plataforma.",
      statCarriers: "Transportistas por cliente",
      statProtocols: "Múltiples protocolos",
      diagramTitle: "Red de conectividad",
      diagramActive: "Activo",
      sources: [
        { proto: 'EDI', name: 'Operadores logísticos', count: '6' },
        { proto: 'GPS', name: 'Carga completa', count: '9' },
        { proto: 'SFTP', name: 'Paquetería express', count: '2' },
        { proto: 'App', name: 'Transportista local', count: '5' },
        { proto: 'API', name: 'Marítimo / Aéreo', count: '6' },
        { proto: 'GPS', name: 'Flota propia', count: '1' },
      ],
      nodeSubtitle: "Normalización",
      nodeCarriers: "transportistas",
      outputEvents: "Eventos normalizados",
      outputGps: "GPS unificado",
      outputModel: "modelo único →",
    },
    traceability: {
      title: "Trazabilidad de envíos",
      description: "Sea cual sea el modo de transporte, conectamos con múltiples fuentes de datos para procesar los eventos del ciclo de vida del envío. Desde el pedido del cliente hasta la entrega de las mercancías.",
      bullets: [
        "Importación Automática de Envíos",
        "Integración con operadores logísticos de diferentes modos",
        "Estados homogéneos de envíos e incidencias",
        "Acceso a documentos del envío",
      ],
      shipmentRef: "Albarán 10234795",
      pagination: "3 de 40",
      origin: "Origen",
      destination: "Destino",
      status: "Estado",
      delivered: "Entregado",
      tabs: ['Cronología', 'Mercancía', 'Documentos'],
      timeline: [
        { event: 'Mercancía entregada', time: '17/4, 14:20', icon: 'green', done: true },
        { event: 'En reparto', time: '17/4, 11:45', icon: 'green', done: true },
        { event: 'En tránsito — Burgos', time: '17/4, 09:10', icon: 'green', done: true },
        { event: 'Recogida completada', time: '17/4, 07:30', icon: 'green', done: true },
        { event: 'Pedido creado', time: '16/4, 18:00', icon: 'green', done: true },
      ],
    },
    realtime: {
      title: "Seguimiento en tiempo real",
      description: "Visualice la ubicación exacta de todos sus vehículos y envíos con actualizaciones continuas. Nuestro sistema integra múltiples proveedores de GPS para ofrecerle una vista unificada de su operación logística.",
      bullets: [
        "Conexión a sistemas telemáticos",
        "Detección inteligente de entregas",
        "Plazo de entrega, ETA avanzado y desviaciones",
        "Cálculos de ruta y emisiones",
      ],
      routeRef: "Ruta 4820137",
      pagination: "14 de 20",
      routeLabel: "Ruta",
      routeType: "Carga Completa",
      deliveries: "1 de 2 entregas",
      status: "Estado",
      inTransit: "En Tránsito",
      lastUpdate: "Hace 3 min",
      tabs: ['Paradas', 'Eventos', 'Mercancía', 'Envíos', 'Emisiones'],
      stop1City: "Madrid, 28045",
      stop2City: "Bilbao, 48013",
      weight: "22.000 KG",
      visited: "Visitado",
      pending: "Pendiente",
      planned: "Planificado",
      actual: "Real",
      mapTitle: "Mapa de Ruta",
      mapSchematic: "Esquemático",
      mapSatellite: "Satélite",
      legendVisited: "Parada visitada",
      legendNext: "Siguiente parada",
      legendPlanned: "Ruta planificada",
      legendActual: "Ruta real",
    },
    unified: {
      title: "VISIBILIDAD UNIFICADA 360",
      cards: [
        {
          title: "Equipos internos",
          description: "Acceso y configuración personalizada para los equipos de logística, soporte y comercial."
        },
        {
          title: "Clientes",
          description: "Información del envío personalizada para sus clientes, mediante enlaces o portal embebible en su propia web."
        },
        {
          title: "Transportistas",
          description: "Acceso a la información de sus envíos y documentación digital desde cualquier dispositivo."
        }
      ],
    },
    ctaFeatures: [
      "Trazabilidad de Envíos",
      "Seguimiento de envíos en Tiempo Real",
      "Herramientas para mis equipos",
      "Información para Clientes",
      "Integración con Transportistas"
    ],
  },
  en: {
    seo: {
      title: "Cadenia Visibility - Real-Time Shipment Tracking and Traceability",
      description: "Centralize data from all your carriers in a single platform. End-to-end shipment tracking with traceability, dynamic ETAs, proactive alerts and unified 360 visibility.",
      keywords: "shipment traceability, real-time tracking, supply chain visibility, dynamic ETA, GPS transport tracking, logistics alerts, shipment management",
    },
    benefits: [
      {
        title: "Single Source of Truth",
        description: "Internal teams, customers and suppliers work from the same up-to-date information, improving coordination and trust."
      },
      {
        title: "Proactive Management",
        description: "Anticipate delays and resolve incidents with early alerts and dynamic ETAs."
      },
      {
        title: "Operational Efficiency",
        description: "Tools designed to make your supply chain more efficient."
      }
    ],
    hero: {
      subtitle: "Centralize data from all your carriers in a single platform. End-to-end shipment tracking with real-time traceability and visibility, dynamic ETAs and proactive incident management.",
      cta: "See a Visibility Demo",
    },
    mockup: {
      moduleLabel: "Module",
      submenu: ['Search', 'Shipments', 'Routes', 'Real Time'],
      bottomItems: ['Support', 'My Profile'],
      pageTitle: "All Shipments",
      toolbarButtons: ['Filters', 'Sorting', 'Excel'],
      refresh: "Refresh",
      views: [
        { label: 'All Shipments', active: true },
        { label: 'Awaiting pickup', active: false },
        { label: 'In transit', active: false },
        { label: 'Incidents', active: false },
      ],
      columns: {
        reference: "Reference",
        route: "Origin → Destination",
        date: "Date",
        status: "Status",
        carrier: "Carrier",
      },
      rows: [
        { ref: '10234801', from: 'Madrid, 28045', to: 'Sevilla, 41012', date: '21/4', status: 'Pending', statusStyle: 'bg-slate-50 text-slate-600 border-slate-200', barColor: 'bg-slate-300', barWidth: 'w-1/6', carrier: 'TR. LÓPEZ' },
        { ref: '10234798', from: 'Barcelona, 08019', to: 'Valencia, 46021', date: '21/4', status: 'Pending', statusStyle: 'bg-slate-50 text-slate-600 border-slate-200', barColor: 'bg-slate-300', barWidth: 'w-1/6', carrier: 'LOGÍSTICA SUR' },
        { ref: '10234795', from: 'Zaragoza, 50018', to: 'Bilbao, 48013', date: '17/4', status: 'Delivered', statusStyle: 'bg-green-50 text-green-700 border-green-200', barColor: 'bg-green-500', barWidth: 'w-full', carrier: 'NORTE EXPRESS' },
        { ref: '10234790', from: 'Valencia, 46021', to: 'Málaga, 29010', date: '20/4', status: 'In Transit', statusStyle: 'bg-slate-50 text-slate-600 border-slate-200', barColor: 'bg-blue-400', barWidth: 'w-3/5', carrier: 'TR. GARCÍA' },
        { ref: '10234787', from: 'Sevilla, 41012', to: 'Barcelona, 08019', date: '17/4', status: 'In Transit', statusStyle: 'bg-slate-50 text-slate-600 border-slate-200', barColor: 'bg-blue-400', barWidth: 'w-2/5', carrier: 'IBÉRICA LOG.' },
        { ref: '10234782', from: 'Bilbao, 48013', to: 'Madrid, 28045', date: '20/4', status: 'In Transit', statusStyle: 'bg-slate-50 text-slate-600 border-slate-200', barColor: 'bg-blue-400', barWidth: 'w-4/5', carrier: 'LOGÍSTICA SUR' },
      ],
      mobileRows: [
        { ref: '10234801', from: 'Madrid, 28045', to: 'Sevilla, 41012', status: 'Pending', statusStyle: 'bg-slate-50 text-slate-600 border-slate-200', barColor: 'bg-slate-300', barWidth: 'w-1/6', carrier: 'TR. LÓPEZ', date: '21/4' },
        { ref: '10234795', from: 'Zaragoza, 50018', to: 'Bilbao, 48013', status: 'Delivered', statusStyle: 'bg-green-50 text-green-700 border-green-200', barColor: 'bg-green-500', barWidth: 'w-full', carrier: 'NORTE EXPRESS', date: '17/4' },
        { ref: '10234790', from: 'Valencia, 46021', to: 'Málaga, 29010', status: 'In Transit', statusStyle: 'bg-slate-50 text-slate-600 border-slate-200', barColor: 'bg-blue-400', barWidth: 'w-3/5', carrier: 'TR. GARCÍA', date: '20/4' },
        { ref: '10234787', from: 'Sevilla, 41012', to: 'Barcelona, 08019', status: 'In Transit', statusStyle: 'bg-slate-50 text-slate-600 border-slate-200', barColor: 'bg-blue-400', barWidth: 'w-2/5', carrier: 'IBÉRICA LOG.', date: '17/4' },
      ],
      totalShipments: "1,149 shipments",
    },
    connectivity: {
      badge: "CONNECTIVITY",
      titleStart: "All your carriers,",
      titleHighlight: "one single platform",
      p1: "Real-world transport and distribution networks are complex: dozens of providers with very different technologies, formats and capabilities. From the local two-truck carrier to the global logistics operator.",
      p2: "Cadenia specializes in aggregating that heterogeneity. We connect with every player in your supply chain and normalize the information into a single model, no matter the source. Some of our customers operate with more than 50 carrier companies connected to the platform at the same time.",
      statCarriers: "Carriers per customer",
      statProtocols: "Multiple protocols",
      diagramTitle: "Connectivity network",
      diagramActive: "Active",
      sources: [
        { proto: 'EDI', name: 'Logistics operators', count: '6' },
        { proto: 'GPS', name: 'Full truckload', count: '9' },
        { proto: 'SFTP', name: 'Express parcel', count: '2' },
        { proto: 'App', name: 'Local carrier', count: '5' },
        { proto: 'API', name: 'Ocean / Air', count: '6' },
        { proto: 'GPS', name: 'Own fleet', count: '1' },
      ],
      nodeSubtitle: "Normalization",
      nodeCarriers: "carriers",
      outputEvents: "Normalized events",
      outputGps: "Unified GPS",
      outputModel: "single model →",
    },
    traceability: {
      title: "Shipment traceability",
      description: "Whatever the transport mode, we connect to multiple data sources to process every event in the shipment lifecycle. From the customer order to the delivery of the goods.",
      bullets: [
        "Automated Shipment Import",
        "Integration with logistics operators across transport modes",
        "Standardized shipment and incident statuses",
        "Access to shipment documents",
      ],
      shipmentRef: "Delivery note 10234795",
      pagination: "3 of 40",
      origin: "Origin",
      destination: "Destination",
      status: "Status",
      delivered: "Delivered",
      tabs: ['Timeline', 'Goods', 'Documents'],
      timeline: [
        { event: 'Goods delivered', time: '17/4, 14:20', icon: 'green', done: true },
        { event: 'Out for delivery', time: '17/4, 11:45', icon: 'green', done: true },
        { event: 'In transit — Burgos', time: '17/4, 09:10', icon: 'green', done: true },
        { event: 'Pickup completed', time: '17/4, 07:30', icon: 'green', done: true },
        { event: 'Order created', time: '16/4, 18:00', icon: 'green', done: true },
      ],
    },
    realtime: {
      title: "Real-time tracking",
      description: "See the exact location of all your vehicles and shipments with continuous updates. Our system integrates multiple GPS providers to give you a unified view of your logistics operation.",
      bullets: [
        "Connection to telematics systems",
        "Smart delivery detection",
        "Delivery lead time, advanced ETA and deviations",
        "Route and emissions calculations",
      ],
      routeRef: "Route 4820137",
      pagination: "14 of 20",
      routeLabel: "Route",
      routeType: "Full Truckload",
      deliveries: "1 of 2 deliveries",
      status: "Status",
      inTransit: "In Transit",
      lastUpdate: "3 min ago",
      tabs: ['Stops', 'Events', 'Goods', 'Shipments', 'Emissions'],
      stop1City: "Madrid, 28045",
      stop2City: "Bilbao, 48013",
      weight: "22,000 KG",
      visited: "Visited",
      pending: "Pending",
      planned: "Planned",
      actual: "Actual",
      mapTitle: "Route Map",
      mapSchematic: "Schematic",
      mapSatellite: "Satellite",
      legendVisited: "Visited stop",
      legendNext: "Next stop",
      legendPlanned: "Planned route",
      legendActual: "Actual route",
    },
    unified: {
      title: "UNIFIED 360 VISIBILITY",
      cards: [
        {
          title: "Internal teams",
          description: "Personalized access and configuration for logistics, support and sales teams."
        },
        {
          title: "Customers",
          description: "Personalized shipment information for your customers, via links or a portal you can embed in your own website."
        },
        {
          title: "Carriers",
          description: "Access to their shipment information and digital documentation from any device."
        }
      ],
    },
    ctaFeatures: [
      "Shipment Traceability",
      "Real-Time Shipment Tracking",
      "Tools for My Teams",
      "Customer-Facing Information",
      "Carrier Integration"
    ],
  },
};

const VisibilityDetail = () => {
  const t = useT(T);

  const benefits = t.benefits;

  return (
    <div className="pt-20">
      <PageSEO
        title={t.seo.title}
        description={t.seo.description}
        keywords={t.seo.keywords}
      />
      {/* Hero mejorado */}
      <section className="py-32 bg-gradient-to-br from-slate-50 via-white to-blue-50 relative overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(59,130,246,0.08),transparent_50%)] animate-pulse" style={{animationDuration: '9s'}} />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_80%,rgba(16,52,236,0.06),transparent_50%)] animate-pulse" style={{animationDuration: '13s', animationDelay: '2s'}} />

        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-50 border border-blue-100 rounded-full text-sm font-medium text-blue-700 mb-8">
              <div className="w-2 h-2 bg-blue-500 rounded-full animate-pulse"></div>
              CADENIA VISIBILITY
            </div>

            <h1 className="text-5xl md:text-7xl font-light text-slate-900 mb-6 leading-tight">
              <span className="bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent font-medium">
                Cadenia
              </span>
              <span className="block font-light">Visibility</span>
            </h1>

            <p className="text-xl md:text-2xl text-slate-600 max-w-4xl mx-auto leading-relaxed mb-12">
              {t.hero.subtitle}
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a href="#demo" className="inline-flex items-center justify-center px-12 py-4 bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white font-medium rounded-lg shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-200">
                {t.hero.cta}
              </a>
            </div>
          </div>

          {/* Ilustración — app shell estilo producto */}
          <div className="relative max-w-5xl mx-auto">
            <div className="absolute -inset-4 bg-gradient-to-r from-slate-900 to-slate-800 rounded-2xl opacity-10 blur-lg"></div>
            <div className="relative bg-white rounded-2xl border border-slate-200 shadow-2xl overflow-hidden">
              <div className="flex">
                {/* Sidebar — estructura real de la app */}
                <div className="w-14 md:w-44 bg-slate-50 border-r border-slate-200 py-4 flex flex-col flex-shrink-0">
                  {/* Logo placeholder */}
                  <div className="px-3 md:px-4 mb-5">
                    <div className="w-8 h-8 md:w-10 md:h-10 bg-slate-200 rounded-lg"></div>
                  </div>
                  {/* Module label */}
                  <div className="px-3 md:px-4 mb-1 hidden md:block">
                    <span className="text-[9px] text-slate-400 uppercase tracking-wider font-medium">{t.mockup.moduleLabel}</span>
                  </div>
                  {/* Active module */}
                  <div className="px-2 md:px-3 mb-1">
                    <div className="flex items-center gap-2 px-2 py-1.5 bg-blue-600 rounded-lg">
                      <div className="w-4 h-4 bg-white/30 rounded flex-shrink-0"></div>
                      <span className="text-[10px] text-white font-medium hidden md:block">Visibility</span>
                      <svg className="w-3 h-3 text-white/60 ml-auto hidden md:block" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" /></svg>
                    </div>
                  </div>
                  {/* Submenu items */}
                  <div className="px-2 md:px-3 space-y-0.5">
                    {t.mockup.submenu.map((item, i) => (
                      <div key={i} className={`flex items-center gap-2 px-2 py-1.5 rounded-md ${i === 1 ? 'bg-blue-50' : ''}`}>
                        <div className={`w-3.5 h-3.5 rounded flex-shrink-0 ${i === 1 ? 'bg-blue-200' : 'bg-slate-200'}`}></div>
                        <span className={`text-[10px] hidden md:block ${i === 1 ? 'text-blue-700 font-medium' : 'text-slate-500'}`}>{item}</span>
                      </div>
                    ))}
                  </div>
                  {/* Bottom items */}
                  <div className="mt-auto px-2 md:px-3 space-y-0.5">
                    {t.mockup.bottomItems.map((item, i) => (
                      <div key={i} className="flex items-center gap-2 px-2 py-1.5">
                        <div className="w-3.5 h-3.5 bg-slate-200 rounded flex-shrink-0"></div>
                        <span className="text-[10px] text-slate-400 hidden md:block">{item}</span>
                      </div>
                    ))}
                  </div>
                </div>
                {/* Main content */}
                <div className="flex-1 min-w-0">
                  {/* Page header */}
                  <div className="px-5 md:px-8 pt-5 md:pt-6 pb-4">
                    <div className="flex items-center justify-between mb-3">
                      <h3 className="text-sm md:text-base font-medium text-slate-800">{t.mockup.pageTitle}</h3>
                      <div className="flex items-center gap-1.5">
                        {t.mockup.toolbarButtons.map((btn, i) => (
                          <div key={i} className="px-2 py-1 bg-white border border-slate-200 rounded text-[9px] text-slate-500 hidden md:flex items-center gap-1">
                            <div className="w-2.5 h-2.5 bg-slate-300 rounded-sm"></div>
                            {btn}
                          </div>
                        ))}
                        <div className="px-2.5 py-1 bg-blue-600 rounded text-[9px] text-white font-medium">{t.mockup.refresh}</div>
                      </div>
                    </div>
                    {/* Views tabs */}
                    <div className="flex items-center gap-1">
                      {t.mockup.views.map((view, i) => (
                        <div key={i} className={`px-2.5 py-1 rounded-md text-[9px] font-medium ${view.active ? 'bg-blue-100 text-blue-700 border border-blue-200' : 'text-slate-400 hover:bg-slate-50'}`}>
                          {view.label}
                        </div>
                      ))}
                    </div>
                  </div>
                  {/* Table — desktop */}
                  <div className="px-5 md:px-8 pb-5 md:pb-6">
                    <div className="border border-slate-200 rounded-lg overflow-hidden hidden md:block">
                      {/* Table header */}
                      <div className="grid grid-cols-12 gap-2 px-4 py-2 bg-slate-50 border-b border-slate-200">
                        <div className="col-span-2"><span className="text-[9px] font-medium text-slate-500 uppercase tracking-wider">{t.mockup.columns.reference}</span></div>
                        <div className="col-span-4"><span className="text-[9px] font-medium text-slate-500 uppercase tracking-wider">{t.mockup.columns.route}</span></div>
                        <div className="col-span-2"><span className="text-[9px] font-medium text-slate-500 uppercase tracking-wider">{t.mockup.columns.date}</span></div>
                        <div className="col-span-2"><span className="text-[9px] font-medium text-slate-500 uppercase tracking-wider">{t.mockup.columns.status}</span></div>
                        <div className="col-span-2"><span className="text-[9px] font-medium text-slate-500 uppercase tracking-wider">{t.mockup.columns.carrier}</span></div>
                      </div>
                      {/* Table rows */}
                      {t.mockup.rows.map((row, i) => (
                        <div key={i} className={`grid grid-cols-12 gap-2 px-4 py-2.5 border-b border-slate-50 items-center ${i === 3 ? 'bg-blue-50/40' : 'hover:bg-slate-50/50'}`}>
                          <div className="col-span-2">
                            <span className="text-[11px] font-mono text-slate-700">{row.ref}</span>
                          </div>
                          <div className="col-span-4">
                            <div className="text-[10px] text-slate-600 truncate">{row.from}</div>
                            <div className="text-[10px] text-slate-400 truncate">{row.to}</div>
                          </div>
                          <div className="col-span-2">
                            <span className="text-[10px] text-slate-500">{row.date}</span>
                          </div>
                          <div className="col-span-2">
                            <span className={`text-[9px] font-medium px-2 py-0.5 rounded border ${row.statusStyle}`}>{row.status}</span>
                            <div className="w-full h-1 bg-slate-100 rounded-full mt-1.5">
                              <div className={`h-full rounded-full ${row.barColor} ${row.barWidth}`}></div>
                            </div>
                          </div>
                          <div className="col-span-2">
                            <span className="text-[10px] text-slate-500">{row.carrier}</span>
                          </div>
                        </div>
                      ))}
                    </div>
                    {/* Cards — mobile */}
                    <div className="space-y-2 md:hidden">
                      {t.mockup.mobileRows.map((row, i) => (
                        <div key={i} className="border border-slate-200 rounded-lg p-3">
                          <div className="flex items-center justify-between mb-2">
                            <span className="text-[11px] font-mono font-medium text-slate-700">{row.ref}</span>
                            <div className="flex flex-col items-end">
                              <span className={`text-[9px] font-medium px-2 py-0.5 rounded border ${row.statusStyle}`}>{row.status}</span>
                              <div className="w-12 h-1 bg-slate-100 rounded-full mt-1">
                                <div className={`h-full rounded-full ${row.barColor} ${row.barWidth}`}></div>
                              </div>
                            </div>
                          </div>
                          <div className="flex items-center gap-1 text-[10px] mb-1">
                            <span className="text-slate-600">{row.from}</span>
                            <svg className="w-3 h-3 text-slate-300 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg>
                            <span className="text-slate-600">{row.to}</span>
                          </div>
                          <div className="flex items-center gap-2 text-[9px] text-slate-400">
                            <span>{row.carrier}</span>
                            <span>·</span>
                            <span>{row.date}</span>
                          </div>
                        </div>
                      ))}
                    </div>
                    {/* Footer */}
                    <div className="flex items-center justify-between mt-3">
                      <span className="text-[10px] text-slate-400">{t.mockup.totalShipments}</span>
                      <div className="flex items-center gap-1">
                        <div className="w-5 h-5 border border-slate-200 rounded flex items-center justify-center">
                          <svg className="w-3 h-3 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" /></svg>
                        </div>
                        <span className="text-[10px] text-slate-400 font-mono px-1">1 / 23</span>
                        <div className="w-5 h-5 border border-slate-200 rounded flex items-center justify-center">
                          <svg className="w-3 h-3 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <BenefitsSection benefits={benefits} />

      {/* Agregación de transportistas */}
      <section className="py-24 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-blue-50 border border-blue-100 rounded-full text-xs font-medium text-blue-700 mb-6">
                {t.connectivity.badge}
              </div>
              <h2 className="text-4xl md:text-5xl font-light text-slate-900 mb-8">
                {t.connectivity.titleStart}{' '}
                <span className="bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent font-medium">
                  {t.connectivity.titleHighlight}
                </span>
              </h2>
              <p className="text-xl text-slate-600 mb-6 leading-relaxed">
                {t.connectivity.p1}
              </p>
              <p className="text-lg text-slate-600 mb-8 leading-relaxed">
                {t.connectivity.p2}
              </p>
              <div className="grid grid-cols-2 gap-6">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-blue-50 rounded-lg flex items-center justify-center flex-shrink-0">
                    <svg className="w-5 h-5 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                    </svg>
                  </div>
                  <div>
                    <div className="text-2xl font-light text-slate-900">50+</div>
                    <div className="text-xs text-slate-500">{t.connectivity.statCarriers}</div>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-indigo-50 rounded-lg flex items-center justify-center flex-shrink-0">
                    <svg className="w-5 h-5 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
                    </svg>
                  </div>
                  <div>
                    <div className="text-2xl font-light text-slate-900">API + EDI</div>
                    <div className="text-xs text-slate-500">{t.connectivity.statProtocols}</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="relative">
              <div className="bg-white rounded-2xl border border-slate-200 shadow-lg overflow-hidden">
                {/* Architecture-style diagram */}
                <div className="p-6 md:p-8">
                  {/* Header bar */}
                  <div className="flex items-center justify-between mb-6 pb-4 border-b border-slate-100">
                    <div className="flex items-center gap-2">
                      <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                      <span className="text-[11px] font-medium text-slate-500 uppercase tracking-wider">{t.connectivity.diagramTitle}</span>
                    </div>
                    <div className="flex items-center gap-1.5">
                      <div className="w-1.5 h-1.5 bg-green-500 rounded-full"></div>
                      <span className="text-[10px] text-slate-400">{t.connectivity.diagramActive}</span>
                    </div>
                  </div>

                  {/* Source nodes - left column */}
                  <div className="flex gap-4 md:gap-6 items-stretch">
                    <div className="flex-1 space-y-2.5">
                      {t.connectivity.sources.map((source, i) => (
                        <div key={i} className="flex items-center gap-2 group">
                          <div className="flex-1 flex items-center gap-2 px-3 py-2 bg-slate-50 border border-slate-200 rounded-lg">
                            <span className="text-[9px] font-mono font-medium text-slate-400 bg-slate-100 px-1.5 py-0.5 rounded">{source.proto}</span>
                            <span className="text-[11px] text-slate-600 truncate">{source.name}</span>
                            <span className="text-[10px] text-slate-400 ml-auto font-mono">{source.count}</span>
                          </div>
                          <div className="w-6 flex items-center justify-center flex-shrink-0">
                            <div className="w-full h-px bg-slate-300"></div>
                            <div className="w-1 h-1 bg-slate-400 rounded-full absolute"></div>
                          </div>
                        </div>
                      ))}
                    </div>

                    {/* Central aggregation node */}
                    <div className="flex flex-col items-center justify-center flex-shrink-0 w-28 md:w-32">
                      <div className="w-full border border-blue-200 bg-gradient-to-b from-blue-50 to-white rounded-xl p-3 text-center shadow-sm">
                        <div className="w-8 h-8 bg-slate-900 rounded-lg flex items-center justify-center mx-auto mb-2">
                          <svg className="w-4 h-4 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4" />
                          </svg>
                        </div>
                        <div className="text-[10px] font-medium text-slate-700 leading-tight">Cadenia</div>
                        <div className="text-[9px] text-slate-500 mt-0.5">{t.connectivity.nodeSubtitle}</div>
                        <div className="mt-2 pt-2 border-t border-blue-100">
                          <div className="text-lg font-light text-slate-900">29</div>
                          <div className="text-[9px] text-slate-400">{t.connectivity.nodeCarriers}</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Output bar */}
                  <div className="mt-5 pt-4 border-t border-slate-100 flex items-center justify-between">
                    <div className="flex items-center gap-4">
                      <div className="flex items-center gap-1.5">
                        <div className="w-1.5 h-1.5 bg-green-500 rounded-full"></div>
                        <span className="text-[10px] text-slate-500">{t.connectivity.outputEvents}</span>
                      </div>
                      <div className="flex items-center gap-1.5">
                        <div className="w-1.5 h-1.5 bg-blue-500 rounded-full"></div>
                        <span className="text-[10px] text-slate-500">{t.connectivity.outputGps}</span>
                      </div>
                    </div>
                    <span className="text-[10px] text-slate-400 font-mono">{t.connectivity.outputModel}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Trazabilidad de envíos */}
      <section className="py-24 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-4xl md:text-5xl font-light text-slate-900 mb-8">
                {t.traceability.title}
              </h2>
              <p className="text-xl text-slate-600 mb-8 leading-relaxed">
                {t.traceability.description}
              </p>
              <ul className="space-y-4">
                {t.traceability.bullets.map((bullet, i) => (
                  <li key={i} className="flex items-start">
                    <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 mr-4 flex-shrink-0"></div>
                    <span className="text-slate-700">{bullet}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div className="relative">
              <div className="bg-white rounded-2xl border border-slate-200 shadow-lg overflow-hidden">
                <div className="flex">
                  {/* Mini sidebar */}
                  <div className="w-10 md:w-12 bg-slate-50 border-r border-slate-200 py-3 flex flex-col items-center gap-3 flex-shrink-0">
                    <div className="w-5 h-5 bg-slate-200 rounded"></div>
                    <div className="w-4 h-4 bg-slate-200 rounded"></div>
                    <div className="w-4 h-4 bg-blue-200 rounded"></div>
                    <div className="w-4 h-4 bg-slate-200 rounded"></div>
                  </div>
                  <div className="flex-1 min-w-0">
                    {/* Detail header — shipment view */}
                    <div className="px-4 md:px-6 pt-4 pb-3 border-b border-slate-100">
                      <div className="flex items-center gap-2 mb-3">
                        <svg className="w-3.5 h-3.5 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" /></svg>
                        <span className="text-xs font-mono font-medium text-slate-700">{t.traceability.shipmentRef}</span>
                        <div className="ml-auto flex items-center gap-1.5">
                          <span className="text-[9px] text-slate-400 font-mono hidden md:block">{t.traceability.pagination}</span>
                          <svg className="w-3 h-3 text-slate-300" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg>
                        </div>
                      </div>
                      {/* Info cards row */}
                      <div className="grid grid-cols-3 gap-2">
                        <div className="bg-slate-50 rounded-lg p-2.5 border border-slate-100">
                          <div className="text-[8px] text-slate-400 uppercase tracking-wider mb-1">{t.traceability.origin}</div>
                          <div className="text-[10px] text-slate-700 font-medium">Madrid, 28045</div>
                          <div className="text-[9px] text-slate-400 mt-0.5">17/4, 07:30</div>
                        </div>
                        <div className="bg-slate-50 rounded-lg p-2.5 border border-slate-100">
                          <div className="text-[8px] text-slate-400 uppercase tracking-wider mb-1">{t.traceability.destination}</div>
                          <div className="text-[10px] text-slate-700 font-medium">Bilbao, 48013</div>
                          <div className="text-[9px] text-slate-400 mt-0.5">17/4, 14:20</div>
                        </div>
                        <div className="bg-green-50 rounded-lg p-2.5 border border-green-200">
                          <div className="text-[8px] text-green-600 uppercase tracking-wider mb-1">{t.traceability.status}</div>
                          <div className="text-[10px] text-green-700 font-medium">{t.traceability.delivered}</div>
                          <div className="w-full h-1 bg-green-200 rounded-full mt-1.5"><div className="h-full bg-green-500 rounded-full w-full"></div></div>
                        </div>
                      </div>
                    </div>
                    {/* Tabs */}
                    <div className="px-4 md:px-6 pt-3 flex items-center gap-3 border-b border-slate-100">
                      {t.traceability.tabs.map((tab, i) => (
                        <span key={i} className={`text-[10px] pb-2 ${i === 0 ? 'text-blue-600 font-medium border-b-2 border-blue-600' : 'text-slate-400'}`}>{tab}</span>
                      ))}
                    </div>
                    {/* Timeline */}
                    <div className="px-4 md:px-6 py-4">
                      <div className="space-y-0">
                        {t.traceability.timeline.map((step, i) => (
                          <div key={i} className="flex items-start gap-3">
                            <div className="flex flex-col items-center">
                              <div className={`w-2.5 h-2.5 rounded-full flex-shrink-0 ${step.done ? 'bg-green-500' : 'bg-slate-300'}`}></div>
                              {i < 4 && <div className={`w-px h-6 ${step.done ? 'bg-green-200' : 'bg-slate-200'}`}></div>}
                            </div>
                            <div className="flex-1 flex items-baseline justify-between -mt-0.5">
                              <span className="text-[10px] text-slate-600">{step.event}</span>
                              <span className="text-[9px] text-slate-400 font-mono ml-2">{step.time}</span>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Seguimiento en tiempo real */}
      <section className="py-24 bg-slate-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div className="lg:order-2">
              <h2 className="text-4xl md:text-5xl font-light text-slate-900 mb-8">
                {t.realtime.title}
              </h2>
              <p className="text-xl text-slate-600 mb-8 leading-relaxed">
                {t.realtime.description}
              </p>
              <ul className="space-y-4">
                {t.realtime.bullets.map((bullet, i) => (
                  <li key={i} className="flex items-start">
                    <div className="w-2 h-2 bg-blue-500 rounded-full mt-2 mr-4 flex-shrink-0"></div>
                    <span className="text-slate-700">{bullet}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div className="lg:order-1 relative">
              <div className="bg-white rounded-2xl border border-slate-200 shadow-lg overflow-hidden">
                <div className="flex">
                  {/* Mini sidebar */}
                  <div className="w-10 md:w-12 bg-slate-50 border-r border-slate-200 py-3 flex flex-col items-center gap-3 flex-shrink-0">
                    <div className="w-5 h-5 bg-slate-200 rounded"></div>
                    <div className="w-4 h-4 bg-slate-200 rounded"></div>
                    <div className="w-4 h-4 bg-blue-200 rounded"></div>
                    <div className="w-4 h-4 bg-slate-200 rounded"></div>
                  </div>
                  <div className="flex-1 min-w-0">
                    {/* Route header */}
                    <div className="px-4 md:px-6 pt-4 pb-3 border-b border-slate-100">
                      <div className="flex items-center gap-2 mb-3">
                        <svg className="w-3.5 h-3.5 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" /></svg>
                        <span className="text-xs font-mono font-medium text-slate-700">{t.realtime.routeRef}</span>
                        <div className="ml-auto flex items-center gap-1.5">
                          <span className="text-[9px] text-slate-400 font-mono hidden md:block">{t.realtime.pagination}</span>
                        </div>
                      </div>
                      <div className="grid grid-cols-3 gap-2">
                        <div className="bg-slate-50 rounded-lg p-2.5 border border-slate-100">
                          <div className="text-[8px] text-slate-400 uppercase tracking-wider mb-1">{t.realtime.routeLabel}</div>
                          <div className="text-[10px] text-slate-700 font-medium">{t.realtime.routeType}</div>
                          <div className="text-[9px] text-slate-400 mt-0.5">{t.realtime.deliveries}</div>
                        </div>
                        <div className="bg-blue-50 rounded-lg p-2.5 border border-blue-200">
                          <div className="text-[8px] text-blue-500 uppercase tracking-wider mb-1">{t.realtime.status}</div>
                          <div className="text-[10px] text-blue-700 font-medium">{t.realtime.inTransit}</div>
                          <div className="w-full h-1 bg-blue-200 rounded-full mt-1.5"><div className="h-full bg-blue-500 rounded-full w-3/5"></div></div>
                        </div>
                        <div className="bg-slate-50 rounded-lg p-2.5 border border-slate-100">
                          <div className="text-[8px] text-slate-400 uppercase tracking-wider mb-1">Tracking</div>
                          <div className="flex items-center gap-1">
                            <span className="text-[10px] text-slate-700 font-medium">GPS</span>
                            <div className="w-1.5 h-1.5 bg-green-500 rounded-full"></div>
                            <span className="text-[9px] text-green-600">ON</span>
                          </div>
                          <div className="text-[9px] text-slate-400 mt-0.5">{t.realtime.lastUpdate}</div>
                        </div>
                      </div>
                    </div>
                    {/* Tabs */}
                    <div className="px-4 md:px-6 pt-3 flex items-center gap-4 border-b border-slate-100">
                      {t.realtime.tabs.map((tab, i) => (
                        <span key={i} className={`text-[10px] pb-2 ${i === 0 ? 'text-blue-600 font-medium border-b-2 border-blue-600' : 'text-slate-400'}`}>{tab}</span>
                      ))}
                    </div>
                    {/* Map + stops layout */}
                    <div className="grid grid-cols-1 md:grid-cols-5 gap-0">
                      {/* Stops panel */}
                      <div className="md:col-span-2 px-4 md:px-5 py-4 md:border-r border-b md:border-b-0 border-slate-100">
                        <div className="space-y-1">
                          {/* Stop 1 — visited */}
                          <div className="border border-slate-200 rounded-lg p-3">
                            <div className="flex items-start justify-between mb-1.5">
                              <div>
                                <div className="text-[10px] text-slate-700 font-medium">{t.realtime.stop1City}</div>
                                <div className="flex items-center gap-1 mt-0.5">
                                  <div className="w-1.5 h-1.5 bg-green-500 rounded-full"></div>
                                  <span className="text-[9px] text-slate-500">{t.realtime.weight}</span>
                                </div>
                              </div>
                              <span className="text-[8px] text-green-600 bg-green-50 px-1.5 py-0.5 rounded border border-green-200">{t.realtime.visited}</span>
                            </div>
                            <div className="grid grid-cols-2 gap-x-3 mt-2 pt-2 border-t border-slate-100">
                              <div>
                                <div className="text-[8px] text-slate-400">{t.realtime.planned}</div>
                                <div className="text-[9px] text-slate-600">17/4, 10:30</div>
                              </div>
                              <div>
                                <div className="text-[8px] text-slate-400">{t.realtime.actual}</div>
                                <div className="text-[9px] text-slate-600">17/4, 07:25</div>
                              </div>
                            </div>
                          </div>
                          {/* Connector */}
                          <div className="flex justify-center py-0.5">
                            <div className="w-px h-3 bg-slate-200"></div>
                          </div>
                          {/* Stop 2 — pending with delay */}
                          <div className="border border-blue-200 bg-blue-50/30 rounded-lg p-3">
                            <div className="flex items-start justify-between mb-1.5">
                              <div>
                                <div className="text-[10px] text-slate-700 font-medium">{t.realtime.stop2City}</div>
                                <div className="flex items-center gap-1 mt-0.5">
                                  <div className="w-1.5 h-1.5 bg-blue-500 rounded-full"></div>
                                  <span className="text-[9px] text-slate-500">{t.realtime.weight}</span>
                                </div>
                              </div>
                              <span className="text-[8px] text-blue-600 bg-blue-50 px-1.5 py-0.5 rounded border border-blue-200">{t.realtime.pending}</span>
                            </div>
                            <div className="text-[9px] text-amber-600 font-medium mt-1">+ 2h 15m</div>
                            <div className="grid grid-cols-2 gap-x-3 mt-2 pt-2 border-t border-blue-100">
                              <div>
                                <div className="text-[8px] text-slate-400">{t.realtime.planned}</div>
                                <div className="text-[9px] text-slate-600">17/4, 14:00</div>
                              </div>
                              <div>
                                <div className="text-[8px] text-slate-400">ETA</div>
                                <div className="text-[9px] text-blue-600 font-medium">17/4, 16:15</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Map area */}
                      <div className="md:col-span-3 bg-slate-100 relative overflow-hidden" style={{minHeight: '220px'}}>
                        <div className="absolute top-0 left-0 w-full px-3 pt-2 flex items-center justify-between z-10">
                          <span className="text-[10px] font-medium text-slate-600">{t.realtime.mapTitle}</span>
                          <div className="flex gap-1">
                            <div className="bg-white rounded px-1.5 py-0.5 text-[8px] text-slate-500 border border-slate-200 shadow-sm">{t.realtime.mapSchematic}</div>
                            <div className="bg-white/60 rounded px-1.5 py-0.5 text-[8px] text-slate-400 border border-slate-200">{t.realtime.mapSatellite}</div>
                          </div>
                        </div>
                        {/* Map SVG */}
                        <svg className="absolute inset-0 w-full h-full" viewBox="0 0 300 220">
                          {/* Subtle grid */}
                          <line x1="0" y1="55" x2="300" y2="55" stroke="#e2e8f0" strokeWidth="0.5"/>
                          <line x1="0" y1="110" x2="300" y2="110" stroke="#e2e8f0" strokeWidth="0.5"/>
                          <line x1="0" y1="165" x2="300" y2="165" stroke="#e2e8f0" strokeWidth="0.5"/>
                          <line x1="75" y1="0" x2="75" y2="220" stroke="#e2e8f0" strokeWidth="0.5"/>
                          <line x1="150" y1="0" x2="150" y2="220" stroke="#e2e8f0" strokeWidth="0.5"/>
                          <line x1="225" y1="0" x2="225" y2="220" stroke="#e2e8f0" strokeWidth="0.5"/>
                          {/* Route line — planned */}
                          <path d="M80 170 Q130 120 170 105 T240 55" fill="none" stroke="#94a3b8" strokeWidth="1.5" strokeDasharray="4 3"/>
                          {/* Route line — actual (partial) */}
                          <path d="M80 170 Q120 130 155 115" fill="none" stroke="#3b82f6" strokeWidth="2"/>
                          {/* Detection area */}
                          <circle cx="80" cy="170" r="18" fill="#22c55e" opacity="0.08" stroke="#22c55e" strokeWidth="0.5" strokeDasharray="3 2"/>
                          <circle cx="240" cy="55" r="18" fill="#3b82f6" opacity="0.08" stroke="#3b82f6" strokeWidth="0.5" strokeDasharray="3 2"/>
                          {/* Origin marker — visited */}
                          <circle cx="80" cy="170" r="5" fill="#22c55e" stroke="white" strokeWidth="2"/>
                          {/* Vehicle position */}
                          <circle cx="155" cy="115" r="6" fill="#22c55e" stroke="white" strokeWidth="2.5"/>
                          {/* Vehicle label */}
                          <rect x="163" y="107" width="42" height="14" rx="3" fill="white" stroke="#e2e8f0" strokeWidth="0.5"/>
                          <text x="184" y="117" textAnchor="middle" className="text-[7px]" fill="#64748b" fontFamily="monospace">4820VGR</text>
                          {/* Destination marker — pending */}
                          <circle cx="240" cy="55" r="5" fill="#3b82f6" stroke="white" strokeWidth="2"/>
                        </svg>
                        {/* Legend */}
                        <div className="absolute bottom-2 right-2 bg-white/90 rounded-lg p-2 border border-slate-200 shadow-sm">
                          <div className="space-y-1">
                            <div className="flex items-center gap-1.5">
                              <div className="w-1.5 h-1.5 bg-green-500 rounded-full"></div>
                              <span className="text-[7px] text-slate-500">{t.realtime.legendVisited}</span>
                            </div>
                            <div className="flex items-center gap-1.5">
                              <div className="w-1.5 h-1.5 bg-blue-500 rounded-full"></div>
                              <span className="text-[7px] text-slate-500">{t.realtime.legendNext}</span>
                            </div>
                            <div className="flex items-center gap-1.5">
                              <div className="w-2.5 h-px bg-slate-400" style={{borderTop: '1.5px dashed #94a3b8'}}></div>
                              <span className="text-[7px] text-slate-500">{t.realtime.legendPlanned}</span>
                            </div>
                            <div className="flex items-center gap-1.5">
                              <div className="w-2.5 h-0 border-t-2 border-blue-500"></div>
                              <span className="text-[7px] text-slate-500">{t.realtime.legendActual}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Visibilidad Unificada 360 */}
      <section className="py-24 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-light text-slate-900 mb-6">
              {t.unified.title}
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-xl flex items-center justify-center text-white mb-6 mx-auto">
                <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-medium text-slate-900 mb-4">{t.unified.cards[0].title}</h3>
              <p className="text-slate-600">{t.unified.cards[0].description}</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-xl flex items-center justify-center text-white mb-6 mx-auto">
                <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
              </div>
              <h3 className="text-xl font-medium text-slate-900 mb-4">{t.unified.cards[1].title}</h3>
              <p className="text-slate-600">{t.unified.cards[1].description}</p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-xl flex items-center justify-center text-white mb-6 mx-auto">
                <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-medium text-slate-900 mb-4">{t.unified.cards[2].title}</h3>
              <p className="text-slate-600">{t.unified.cards[2].description}</p>
            </div>
          </div>
        </div>
      </section>



      <ClientLogos />

      <section id="demo" className="py-24 bg-gray-50">
        <ProductCTA
          productName="visibility"
          features={t.ctaFeatures}
        />
      </section>

    </div>
  );
};

export default VisibilityDetail;
